const STYLES = {
  error: 'bg-red-50 border-red-300 text-red-800',
  success: 'bg-green-50 border-green-300 text-green-800',
  info: 'bg-blue-50 border-blue-300 text-blue-800',
};

export default function Notice({ notice, onDismiss }) {
  if (!notice) return null;

  return (
    <div
      role="alert"
      className={`mb-4 border rounded px-4 py-3 text-sm flex justify-between gap-4 ${
        STYLES[notice.type] || STYLES.info
      }`}
    >
      <div>
        <div className="font-medium">{notice.text}</div>
        {notice.lines?.length > 0 && (
          <ul className="mt-1 list-disc list-inside text-xs">
            {notice.lines.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        )}
      </div>
      <button
        onClick={onDismiss}
        aria-label="Dismiss"
        className="text-lg leading-none opacity-60 hover:opacity-100"
      >
        ×
      </button>
    </div>
  );
}
